import { matchPath } from "react-router";
import { appRoutes } from "@/app/router";
import { AppStore } from "@/store";
import { MdsIconKind } from "@/design-system/components/icon";
import { AudioCaptureWaveForm } from "@/components/layout/components/AudioCaptureWaveForm";
import { CollectionIcon } from "@/components/collection/CollectionIcon";

export const getPathIcon = (path: string, store: AppStore): MdsIconKind | React.ReactNode => {
  const noteIdMatch = matchPath(
    appRoutes.notesView({ params: { noteId: ":noteId" }, starPattern: true }),
    path
  );
  if (noteIdMatch?.params.noteId === store.audioCapture.activeNoteId)
    return <AudioCaptureWaveForm />;

  const collectionIdMatch = matchPath(
    appRoutes.collectionsView({ params: { collectionId: ":collectionId" }, starPattern: true }),
    path
  );
  const collectionId = collectionIdMatch?.params.collectionId;
  if (collectionId) return <CollectionIcon size={10} collectionId={collectionId} />;

  if (path.startsWith(appRoutes.search({}).path)) return MdsIconKind.Search;
  if (path === appRoutes.notesList({}).path) return MdsIconKind.Notebook;
  if (path === appRoutes.collections({}).path) return MdsIconKind.Collection;
  if (path === appRoutes.templatesList({}).path) return MdsIconKind.Template;
  if (path.startsWith(appRoutes.integrations({}).path)) return MdsIconKind.BoltOutline;
  if (path.startsWith(appRoutes.settings({}).path)) return MdsIconKind.Settings;
  if (path === appRoutes.trash({}).path) return MdsIconKind.Trash;
  return null;
};
